// import React, { useState, useEffect } from 'react';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { FaPhone, FaEnvelope, FaWhatsapp, FaClock, FaCalendar, FaSave, FaEdit, FaPlus, FaTrash, FaTimes } from 'react-icons/fa';
// import '../../Styles/CustomerCareManagement.css';
// import { useSelector } from 'react-redux';
// import {
//   getCustomerCare,
//   createCustomerCare,
//   updateCustomerCare,
//   deleteCustomerCare,
//   toggleCustomerCareStatus,
// } from '../../Services/Operations/ProductAPI';

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonDetailCard = () => (
//   <div className="detail-card skeleton">
//     <div className="skeleton-icon"></div>
//     <div className="skeleton-content">
//       <div className="skeleton-title"></div>
//       <div className="skeleton-text"></div>
//       <div className="skeleton-text"></div>
//     </div>
//   </div>
// );

// const CustomerCareManagement = () => {
//   const [loading, setLoading] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [customerCare, setCustomerCare] = useState(null);
//   const [error, setError] = useState(null);
//   const { token } = useSelector(state => state.user);

//   const [formData, setFormData] = useState({
//     phoneNumbers: [''],
//     emailAddresses: [''],
//     whatsappNumbers: [''],
//     workingHours: {
//       start: '09:00',
//       end: '18:00'
//     },
//     workingDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
//     supportEmail: '',
//     responseTime: 'Within 24 hours',
//     isActive: true
//   });

//   const fetchCustomerCare = async () => {
//     try {
//       setLoading(true);
//       setError(null);
      
//       const response = await getCustomerCare(token);

//       if (response && response.success) {
//         const data = response.data;
//         setCustomerCare(data);
//         setFormData({
//           phoneNumbers: data.phoneNumbers || [''],
//           emailAddresses: data.emailAddresses || [''],
//           whatsappNumbers: data.whatsappNumbers || [''],
//           workingHours: data.workingHours || { start: '09:00', end: '18:00' },
//           workingDays: data.workingDays || ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
//           supportEmail: data.supportEmail || '',
//           responseTime: data.responseTime || 'Within 24 hours',
//           isActive: data.isActive !== undefined ? data.isActive : true
//         });
//       } else if (response && response.status === 404) {
//         setCustomerCare(null);
//         resetForm();
//       } else {
//         setError('Failed to fetch customer care details');
//       }
//     } catch (err) {
//       console.error('Error fetching customer care:', err);
//       if (err.response?.status === 404) {
//         setCustomerCare(null);
//         resetForm();
//       } else {
//         setError('Failed to fetch customer care details. Please try again.');
//         toast.error('Failed to fetch customer care details');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (token) {
//       fetchCustomerCare();
//     }
//   }, [token]);

//   const resetForm = () => {
//     setFormData({
//       phoneNumbers: [''],
//       emailAddresses: [''],
//       whatsappNumbers: [''],
//       workingHours: {
//         start: '09:00',
//         end: '18:00'
//       },
//       workingDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
//       supportEmail: '',
//       responseTime: 'Within 24 hours',
//       isActive: true
//     });
//   };

//   const handleArrayChange = (field, index, value) => {
//     const newArray = [...formData[field]];
//     newArray[index] = value;
//     setFormData({ ...formData, [field]: newArray });
//   };

//   const addArrayItem = (field) => {
//     setFormData({
//       ...formData,
//       [field]: [...formData[field], '']
//     });
//   };

//   const removeArrayItem = (field, index) => {
//     if (formData[field].length <= 1) {
//       toast.warning('At least one item is required');
//       return;
//     }
//     const newArray = formData[field].filter((_, i) => i !== index);
//     setFormData({ ...formData, [field]: newArray });
//   };

//   const handleWorkingHoursChange = (type, value) => {
//     setFormData({
//       ...formData,
//       workingHours: {
//         ...formData.workingHours,
//         [type]: value
//       }
//     });
//   };

//   const toggleWorkingDay = (day) => {
//     const currentDays = formData.workingDays || [];
//     if (currentDays.includes(day)) {
//       setFormData({
//         ...formData,
//         workingDays: currentDays.filter(d => d !== day)
//       });
//     } else {
//       setFormData({
//         ...formData,
//         workingDays: [...currentDays, day]
//       });
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     const validPhoneNumbers = formData.phoneNumbers.filter(p => p.trim() !== '');
//     if (validPhoneNumbers.length === 0) {
//       toast.error('Please add at least one phone number');
//       return;
//     }

//     const phoneRegex = /^[+\d\s-]{10,15}$/;
//     for (const phone of validPhoneNumbers) {
//       if (!phoneRegex.test(phone.trim())) {
//         toast.error(`Invalid phone number format: ${phone}. Please use format like +91 9876543210`);
//         return;
//       }
//     }

//     const submitData = {
//       ...formData,
//       phoneNumbers: validPhoneNumbers,
//       emailAddresses: formData.emailAddresses.filter(e => e.trim() !== ''),
//       whatsappNumbers: formData.whatsappNumbers.filter(w => w.trim() !== ''),
//       workingDays: formData.workingDays || []
//     };

//     try {
//       setLoading(true);
//       setError(null);
      
//       let response;
//       if (customerCare) {
//         response = await updateCustomerCare(customerCare._id, submitData, token);
//       } else {
//         response = await createCustomerCare(submitData, token);
//       }

//       if (response && response.success) {
//         toast.success(customerCare ? 'Customer care details updated successfully!' : 'Customer care details created successfully!');
//         setCustomerCare(response.data);
//         setIsEditing(false);
//         fetchCustomerCare();
//       } else {
//         throw new Error(response?.message || 'Failed to save customer care details');
//       }
//     } catch (err) {
//       console.error('Error saving customer care:', err);
//       const errorMsg = err.response?.data?.message || err.message || 'Failed to save customer care details';
//       setError(errorMsg);
//       toast.error(errorMsg);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCancel = () => {
//     if (customerCare) {
//       setFormData({
//         phoneNumbers: customerCare.phoneNumbers || [''],
//         emailAddresses: customerCare.emailAddresses || [''],
//         whatsappNumbers: customerCare.whatsappNumbers || [''],
//         workingHours: customerCare.workingHours || { start: '09:00', end: '18:00' },
//         workingDays: customerCare.workingDays || ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
//         supportEmail: customerCare.supportEmail || '',
//         responseTime: customerCare.responseTime || 'Within 24 hours',
//         isActive: customerCare.isActive !== undefined ? customerCare.isActive : true
//       });
//     } else {
//       resetForm();
//     }
//     setIsEditing(false);
//     setError(null);
//   };

//   const handleDelete = async () => {
//     if (!customerCare) return;
    
//     if (window.confirm('Are you sure you want to delete customer care details?')) {
//       try {
//         setLoading(true);
//         const response = await deleteCustomerCare(customerCare._id, token);
//         if (response && response.success) {
//           toast.success('Customer care details deleted successfully!');
//           setCustomerCare(null);
//           resetForm();
//           fetchCustomerCare();
//         } else {
//           throw new Error(response?.message || 'Failed to delete customer care details');
//         }
//       } catch (err) {
//         console.error('Error deleting customer care:', err);
//         toast.error(err.message || 'Failed to delete customer care details');
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   const handleToggleStatus = async () => {
//     if (!customerCare) return;
    
//     try {
//       setLoading(true);
//       const response = await toggleCustomerCareStatus(customerCare._id, token);
//       if (response && response.success) {
//         toast.success(`Customer care ${response.data.isActive ? 'activated' : 'deactivated'} successfully!`);
//         setCustomerCare(response.data);
//         setFormData(prev => ({
//           ...prev,
//           isActive: response.data.isActive
//         }));
//       } else {
//         throw new Error(response?.message || 'Failed to toggle status');
//       }
//     } catch (err) {
//       console.error('Error toggling status:', err);
//       toast.error(err.message || 'Failed to toggle status');
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading && !customerCare && !isEditing) {
//     return (
//       <div className="customer-care-container">
//         <div className="page-header">
//           <h1>📞 Customer Care Management</h1>
//           <p>Loading customer care details...</p>
//         </div>
//         <div className="content-card">
//           <div className="loading-grid">
//             {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
//               <SkeletonDetailCard key={i} />
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   const renderViewMode = () => {
//     if (!customerCare) {
//       return (
//         <div className="empty-state">
//           <div className="empty-icon">📞</div>
//           <h3>No Customer Care Details Found</h3>
//           <p>Click the "Add Customer Care" button to create new details</p>
//           <button className="btn-primary" onClick={() => setIsEditing(true)}>
//             <FaPlus /> Add Customer Care
//           </button>
//         </div>
//       );
//     }

//     return (
//       <div className="customer-care-view">
//         <div className="view-header">
//           <h2>Customer Care Details</h2>
//           <div className="header-actions">
//             <button className="btn-edit" onClick={() => setIsEditing(true)}>
//               <FaEdit /> Edit Details
//             </button>
//             <button className="btn-delete" onClick={handleDelete}>
//               <FaTrash /> Delete
//             </button>
//             <button className={`btn-toggle ${customerCare.isActive ? 'active' : 'inactive'}`} onClick={handleToggleStatus}>
//               {customerCare.isActive ? 'Deactivate' : 'Activate'}
//             </button>
//           </div>
//         </div>

//         {error && (
//           <div className="error-message">
//             {error}
//           </div>
//         )}

//         <div className="details-grid">
//           <div className="detail-card">
//             <div className="detail-icon"><FaPhone /></div>
//             <div className="detail-content">
//               <h4>Phone Numbers</h4>
//               {customerCare.phoneNumbers?.map((phone, index) => (
//                 <p key={index}>{phone}</p>
//               ))}
//             </div>
//           </div>

//           <div className="detail-card">
//             <div className="detail-icon"><FaEnvelope /></div>
//             <div className="detail-content">
//               <h4>Email Addresses</h4>
//               {customerCare.emailAddresses?.map((email, index) => (
//                 <p key={index}>{email}</p>
//               ))}
//             </div>
//           </div>

//           <div className="detail-card">
//             <div className="detail-icon"><FaWhatsapp /></div>
//             <div className="detail-content">
//               <h4>WhatsApp Numbers</h4>
//               {customerCare.whatsappNumbers?.map((whatsapp, index) => (
//                 <p key={index}>{whatsapp}</p>
//               ))}
//             </div>
//           </div>

//           <div className="detail-card">
//             <div className="detail-icon"><FaClock /></div>
//             <div className="detail-content">
//               <h4>Working Hours</h4>
//               <p>{customerCare.workingHours?.start} - {customerCare.workingHours?.end}</p>
//             </div>
//           </div>

//           <div className="detail-card">
//             <div className="detail-icon"><FaCalendar /></div>
//             <div className="detail-content">
//               <h4>Working Days</h4>
//               <p>{customerCare.workingDays?.join(', ')}</p>
//             </div>
//           </div>

//           <div className="detail-card">
//             <div className="detail-icon"><FaEnvelope /></div>
//             <div className="detail-content">
//               <h4>Support Email</h4>
//               <p>{customerCare.supportEmail || 'N/A'}</p>
//             </div>
//           </div>

//           <div className="detail-card full-width">
//             <div className="detail-content">
//               <h4>Response Time</h4>
//               <p>{customerCare.responseTime || 'N/A'}</p>
//             </div>
//           </div>

//           <div className="detail-card full-width">
//             <div className="detail-content">
//               <h4>Status</h4>
//               <span className={`status-badge ${customerCare.isActive ? 'active' : 'inactive'}`}>
//                 {customerCare.isActive ? 'Active' : 'Inactive'}
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderEditMode = () => {
//     const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

//     return (
//       <form onSubmit={handleSubmit} className="customer-care-form">
//         <div className="form-header">
//           <h2>{customerCare ? 'Edit Customer Care Details' : 'Add Customer Care Details'}</h2>
//           <div className="form-actions">
//             <button type="button" className="btn-cancel" onClick={handleCancel}>
//               <FaTimes /> Cancel
//             </button>
//             <button type="submit" className="btn-save" disabled={loading}>
//               <FaSave /> {loading ? 'Saving...' : 'Save'}
//             </button>
//           </div>
//         </div>

//         {error && (
//           <div className="error-message">
//             {error}
//           </div>
//         )}

//         <div className="form-grid">

//           <div className="form-group full-width">
//             <label>Phone Numbers <span className="required">*</span></label>
//             {formData.phoneNumbers.map((phone, index) => (
//               <div key={index} className="array-input">
//                 <input
//                   type="tel"
//                   value={phone}
//                   onChange={(e) => handleArrayChange('phoneNumbers', index, e.target.value)}
//                   placeholder="Enter phone number (e.g., +91 9876543210)"
//                   required
//                 />
//                 <button
//                   type="button"
//                   className="btn-remove"
//                   onClick={() => removeArrayItem('phoneNumbers', index)}
//                 >
//                   <FaTrash />
//                 </button>
//               </div>
//             ))}
//             <button
//               type="button"
//               className="btn-add"
//               onClick={() => addArrayItem('phoneNumbers')}
//             >
//               <FaPlus /> Add Phone Number
//             </button>
//           </div>


//           <div className="form-group full-width">
//             <label>Email Addresses</label>
//             {formData.emailAddresses.map((email, index) => (
//               <div key={index} className="array-input">
//                 <input
//                   type="email"
//                   value={email}
//                   onChange={(e) => handleArrayChange('emailAddresses', index, e.target.value)}
//                   placeholder="Enter email address"
//                 />
//                 <button
//                   type="button"
//                   className="btn-remove"
//                   onClick={() => removeArrayItem('emailAddresses', index)}
//                 >
//                   <FaTrash />
//                 </button>
//               </div>
//             ))}
//             <button
//               type="button"
//               className="btn-add"
//               onClick={() => addArrayItem('emailAddresses')}
//             >
//               <FaPlus /> Add Email Address
//             </button>
//           </div>


//           <div className="form-group full-width">
//             <label>WhatsApp Numbers</label>
//             {formData.whatsappNumbers.map((whatsapp, index) => (
//               <div key={index} className="array-input">
//                 <input
//                   type="tel"
//                   value={whatsapp}
//                   onChange={(e) => handleArrayChange('whatsappNumbers', index, e.target.value)}
//                   placeholder="Enter WhatsApp number"
//                 />
//                 <button
//                   type="button"
//                   className="btn-remove"
//                   onClick={() => removeArrayItem('whatsappNumbers', index)}
//                 >
//                   <FaTrash />
//                 </button>
//               </div>
//             ))}
//             <button
//               type="button"
//               className="btn-add"
//               onClick={() => addArrayItem('whatsappNumbers')}
//             >
//               <FaPlus /> Add WhatsApp Number
//             </button>
//           </div>


//           <div className="form-group">
//             <label>Support Email</label>
//             <input
//               type="email"
//               value={formData.supportEmail}
//               onChange={(e) => setFormData({ ...formData, supportEmail: e.target.value })}
//               placeholder="Enter support email"
//             />
//           </div>


//           <div className="form-group">
//             <label>Response Time</label>
//             <input
//               type="text"
//               value={formData.responseTime}
//               onChange={(e) => setFormData({ ...formData, responseTime: e.target.value })}
//               placeholder="e.g., Within 24 hours"
//             />
//           </div>


//           <div className="form-group">
//             <label>Working Hours Start</label>
//             <input
//               type="time"
//               value={formData.workingHours.start}
//               onChange={(e) => handleWorkingHoursChange('start', e.target.value)}
//             />
//           </div>

//           <div className="form-group">
//             <label>Working Hours End</label>
//             <input
//               type="time"
//               value={formData.workingHours.end}
//               onChange={(e) => handleWorkingHoursChange('end', e.target.value)}
//             />
//           </div>


//           <div className="form-group full-width">
//             <label>Working Days</label>
//             <div className="days-grid">
//               {days.map((day) => (
//                 <label key={day} className="day-checkbox">
//                   <input
//                     type="checkbox"
//                     checked={formData.workingDays?.includes(day)}
//                     onChange={() => toggleWorkingDay(day)}
//                   />
//                   {day}
//                 </label>
//               ))}
//             </div>
//           </div>


//           <div className="form-group full-width">
//             <label>Status</label>
//             <div className="status-toggle">
//               <label className="toggle-label">
//                 <input
//                   type="checkbox"
//                   checked={formData.isActive}
//                   onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
//                 />
//                 <span className="toggle-slider"></span>
//                 {formData.isActive ? 'Active' : 'Inactive'}
//               </label>
//             </div>
//           </div>
//         </div>
//       </form>
//     );
//   };

//   return (
//     <div className="customer-care-container">
//       <ToastContainer position="top-right" autoClose={3000} />
      
//       <div className="page-header">
//         <h1>📞 Customer Care Management</h1>
//         <p>Manage customer support contact details and working hours</p>
//       </div>

//       <div className="content-card">
//         {isEditing ? renderEditMode() : renderViewMode()}
//       </div>
//     </div>
//   );
// };

// export default CustomerCareManagement;

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (avatar, pagination…)
import '../../Styles/CustomerReport.css';       // customer-only additions (load LAST)
import '../../Styles/CustomerCareManagement.css';
import { Icon, BusSvg, StatCard, Field, Avatar, Pagination } from './PrimaryUI';
import {
  getCustomerCare,
  createCustomerCare,
  updateCustomerCare,
  deleteCustomerCare,
  toggleCustomerCareStatus,
} from '../../Services/Operations/ProductAPI';

// ---------- helpers ----------
const safeStr = (v) => (v === null || v === undefined ? '' : String(v));
const safeArr = (v) => (Array.isArray(v) ? v : []);

const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

// ============================================================
// Detail card (read view)
// ============================================================
const InfoCard = ({ icon, title, values, tone = 'indigo', full = false }) => (
  <div className={`prm-card cr-card ${full ? 'full-width' : ''}`}>
    <div className="prm-card-top">
      <div className="pbo-owner-id">
        <span className="prm-form-badge" style={{ width: 42, height: 42 }}>
          <Icon name={icon} size={20} />
        </span>
        <div>
          <div className="prm-card-no">{title}</div>
          <div className="prm-card-sub" style={{ marginTop: 4 }}>
            {values && values.length > 0 ? (
              <ul style={{ margin: 0, paddingLeft: 16, color: '#2d3748' }}>
                {values.map((v, i) => <li key={i}>{v}</li>)}
              </ul>
            ) : (
              <span style={{ color: '#a0aec0' }}>—</span>
            )}
          </div>
        </div>
      </div>
      <span className={`prm-status tone-${tone}`} style={{ visibility: 'hidden' }}>.</span>
    </div>
  </div>
);

// ============================================================
// MAIN
// ============================================================
const CustomerCareManagement = () => {
  const { token } = useSelector(state => state.user);

  const [loading, setLoading] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [customerCare, setCustomerCare] = useState(null);
  const [error, setError] = useState(null);

  const [formData, setFormData] = useState({
    phoneNumbers: [''],
    emailAddresses: [''],
    whatsappNumbers: [''],
    workingHours: { start: '09:00', end: '18:00' },
    workingDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    supportEmail: '',
    responseTime: 'Within 24 hours',
    isActive: true
  });

  // ---------- fetch ----------
  const fetchCustomerCare = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getCustomerCare(token);

      if (response && response.success) {
        const data = response.data;
        setCustomerCare(data);
        setFormData({
          phoneNumbers: data.phoneNumbers || [''],
          emailAddresses: data.emailAddresses || [''],
          whatsappNumbers: data.whatsappNumbers || [''],
          workingHours: data.workingHours || { start: '09:00', end: '18:00' },
          workingDays: data.workingDays || ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          supportEmail: data.supportEmail || '',
          responseTime: data.responseTime || 'Within 24 hours',
          isActive: data.isActive !== undefined ? data.isActive : true
        });
      } else if (response && response.status === 404) {
        setCustomerCare(null);
        resetForm();
      } else {
        setError('Failed to fetch customer care details');
      }
    } catch (err) {
      console.error('Error fetching customer care:', err);
      if (err.response?.status === 404) {
        setCustomerCare(null);
        resetForm();
      } else {
        setError('Failed to fetch customer care details. Please try again.');
        toast.error('Failed to fetch customer care details');
      }
    } finally {
      setLoading(false);
      setFirstLoad(false);
    }
  };

  useEffect(() => { if (token) fetchCustomerCare(); }, [token]); // eslint-disable-line

  const resetForm = () => {
    setFormData({
      phoneNumbers: [''],
      emailAddresses: [''],
      whatsappNumbers: [''],
      workingHours: { start: '09:00', end: '18:00' },
      workingDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      supportEmail: '',
      responseTime: 'Within 24 hours',
      isActive: true
    });
  };

  // ---------- form handlers ----------
  const handleArrayChange = (field, index, value) => {
    const arr = [...formData[field]];
    arr[index] = value;
    setFormData({ ...formData, [field]: arr });
  };

  const addArrayItem = (field) => {
    setFormData({ ...formData, [field]: [...formData[field], ''] });
  };

  const removeArrayItem = (field, index) => {
    if (formData[field].length <= 1) {
      toast.warning('At least one item is required');
      return;
    }
    setFormData({ ...formData, [field]: formData[field].filter((_, i) => i !== index) });
  };

  const handleWorkingHoursChange = (type, value) => {
    setFormData({ ...formData, workingHours: { ...formData.workingHours, [type]: value } });
  };

  const toggleWorkingDay = (day) => {
    const cur = formData.workingDays || [];
    setFormData({
      ...formData,
      workingDays: cur.includes(day) ? cur.filter(d => d !== day) : [...cur, day]
    });
  };

  // ---------- submit / cancel / delete / toggle ----------
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    const validPhoneNumbers = formData.phoneNumbers.filter(p => p.trim() !== '');
    if (validPhoneNumbers.length === 0) {
      toast.error('Please add at least one phone number');
      return;
    }

    const phoneRegex = /^[+\d\s-]{10,15}$/;
    for (const phone of validPhoneNumbers) {
      if (!phoneRegex.test(phone.trim())) {
        toast.error(`Invalid phone number format: ${phone}. Please use format like +91 9876543210`);
        return;
      }
    }

    const submitData = {
      ...formData,
      phoneNumbers: validPhoneNumbers,
      emailAddresses: formData.emailAddresses.filter(e => e.trim() !== ''),
      whatsappNumbers: formData.whatsappNumbers.filter(w => w.trim() !== ''),
      workingDays: formData.workingDays || []
    };

    try {
      setLoading(true);
      setError(null);

      const response = customerCare
        ? await updateCustomerCare(customerCare._id, submitData, token)
        : await createCustomerCare(submitData, token);

      if (response && response.success) {
        toast.success(customerCare ? 'Customer care details updated successfully' : 'Customer care details created successfully');
        setCustomerCare(response.data);
        setIsEditing(false);
        fetchCustomerCare();
      } else {
        throw new Error(response?.message || 'Failed to save customer care details');
      }
    } catch (err) {
      console.error('Error saving customer care:', err);
      const msg = err.response?.data?.message || err.message || 'Failed to save customer care details';
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    if (customerCare) {
      setFormData({
        phoneNumbers: customerCare.phoneNumbers || [''],
        emailAddresses: customerCare.emailAddresses || [''],
        whatsappNumbers: customerCare.whatsappNumbers || [''],
        workingHours: customerCare.workingHours || { start: '09:00', end: '18:00' },
        workingDays: customerCare.workingDays || ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        supportEmail: customerCare.supportEmail || '',
        responseTime: customerCare.responseTime || 'Within 24 hours',
        isActive: customerCare.isActive !== undefined ? customerCare.isActive : true
      });
    } else {
      resetForm();
    }
    setIsEditing(false);
    setError(null);
  };

  const handleDelete = async () => {
    if (!customerCare) return;
    if (!window.confirm('Are you sure you want to delete customer care details?')) return;
    try {
      setLoading(true);
      const response = await deleteCustomerCare(customerCare._id, token);
      if (response && response.success) {
        toast.success('Customer care details deleted successfully');
        setCustomerCare(null);
        resetForm();
        fetchCustomerCare();
      } else {
        throw new Error(response?.message || 'Failed to delete customer care details');
      }
    } catch (err) {
      console.error('Error deleting customer care:', err);
      toast.error(err.message || 'Failed to delete customer care details');
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async () => {
    if (!customerCare) return;
    try {
      setLoading(true);
      const response = await toggleCustomerCareStatus(customerCare._id, token);
      if (response && response.success) {
        toast.success(`Customer care ${response.data.isActive ? 'activated' : 'deactivated'} successfully`);
        setCustomerCare(response.data);
        setFormData(prev => ({ ...prev, isActive: response.data.isActive }));
      } else {
        throw new Error(response?.message || 'Failed to toggle status');
      }
    } catch (err) {
      console.error('Error toggling status:', err);
      toast.error(err.message || 'Failed to toggle status');
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  if (firstLoad && loading) {
    return (
      <div className="prm-page">
        <div className="prm-hero"><div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="phone" size={13} /> Support</span>
          <h1>Customer Care</h1><p>Loading contact details…</p>
        </div></div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">
          {[0, 1, 2].map(i => (
            <div className="prm-skel" key={i}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  const phoneCount = safeArr(customerCare?.phoneNumbers).length;
  const emailCount = safeArr(customerCare?.emailAddresses).length;
  const waCount = safeArr(customerCare?.whatsappNumbers).length;
  const dayCount = safeArr(customerCare?.workingDays).length;

  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true">
          <span className="prm-hero-roadbus"><BusSvg size={46} /></span>
        </div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="phone" size={13} /> Support Contact</span>
          <h1>Customer Care Management</h1>
          <p>Manage support phone numbers, emails, working hours, and availability for your customers.</p>
        </div>
        <div className="prm-hero-actions">
          {customerCare && !isEditing && (
            <>
              <button
                className={`pbo-icon-btn ${customerCare.isActive ? 'active' : ''}`}
                onClick={handleToggleStatus}
                title={customerCare.isActive ? 'Deactivate' : 'Activate'}
              >
                <Icon name={customerCare.isActive ? 'check' : 'x'} size={17} />
              </button>
              <button className="pbo-icon-btn" onClick={handleDelete} title="Delete">
                <Icon name="trash" size={17} />
              </button>
              <button className="prm-add-btn" onClick={() => setIsEditing(true)}>
                <span className="plus"><Icon name="edit" size={14} /></span> Edit Details
              </button>
            </>
          )}
          {(!customerCare || isEditing) && (
            <button className="prm-add-btn" onClick={() => setIsEditing(true)}>
              <span className="plus"><Icon name="plus" size={14} /></span> Add Customer Care
            </button>
          )}
        </div>
      </div>

      {error && (
        <div className="cr-error">
          <Icon name="info" size={16} /> {error}
          <button className="prm-btn ghost sm" onClick={fetchCustomerCare}>Retry</button>
        </div>
      )}

      {/* STATS */}
      {customerCare && !isEditing && (
        <div className="prm-stats">
          <StatCard icon="phone" tone="indigo" label="Phone Numbers" value={phoneCount} hint="Support lines" delay={80} />
          <StatCard icon="mail" tone="cyan" label="Emails" value={emailCount} hint="Contact addresses" delay={160} />
          <StatCard icon="whatsapp" tone="green" label="WhatsApp" value={waCount} hint="WhatsApp lines" delay={240} />
          <StatCard icon="calendar" tone="amber" label="Working Days" value={dayCount} hint={`${safeStr(customerCare.workingHours?.start)} – ${safeStr(customerCare.workingHours?.end)}`} delay={320} />
        </div>
      )}

      {/* CONTENT */}
      {!customerCare && !isEditing ? (
        <div className="prm-empty">
          <div className="icon"><Icon name="phone" size={44} /></div>
          <h3>No customer care details yet</h3>
          <p>Click “Add Customer Care” to configure support contacts and working hours.</p>
          <button className="prm-btn primary" onClick={() => setIsEditing(true)}>
            <Icon name="plus" size={15} /> Add Customer Care
          </button>
        </div>
      ) : !isEditing ? (
        <>
          <div className="prm-section-title">Contact channels</div>
          <div className="prm-grid">
            <InfoCard icon="phone" title="Phone Numbers" values={safeArr(customerCare.phoneNumbers)} />
            <InfoCard icon="mail" title="Email Addresses" values={safeArr(customerCare.emailAddresses)} />
            <InfoCard icon="whatsapp" title="WhatsApp Numbers" values={safeArr(customerCare.whatsappNumbers)} />
          </div>

          <div className="prm-section-title">Hours & Availability</div>
          <div className="prm-grid">
            <InfoCard
              icon="clock"
              title="Working Hours"
              values={[`${safeStr(customerCare.workingHours?.start)} – ${safeStr(customerCare.workingHours?.end)}`]}
            />
            <InfoCard icon="calendar" title="Working Days" values={[safeArr(customerCare.workingDays).join(', ') || '—']} />
            <InfoCard icon="info" title="Response Time" values={[customerCare.responseTime || 'N/A']} />
          </div>

          <div className="prm-section-title">Support</div>
          <div className="prm-grid">
            <InfoCard icon="mail" title="Support Email" values={[customerCare.supportEmail || 'N/A']} />
            <div className="prm-card cr-card">
              <div className="prm-card-top">
                <div className="pbo-owner-id">
                  <span className="prm-form-badge" style={{ width: 42, height: 42 }}>
                    <Icon name="check" size={20} />
                  </span>
                  <div>
                    <div className="prm-card-no">Status</div>
                    <div className="prm-card-sub" style={{ marginTop: 6 }}>
                      <span className={`prm-status ${customerCare.isActive ? 'active' : 'inactive'}`}>
                        {customerCare.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        /* EDIT / CREATE FORM */
        <div className="prm-form-modal" style={{ maxWidth: 900 }}>
          <div className="prm-form-head">
            <div className="prm-form-head-row">
              <span className="prm-form-badge"><Icon name={customerCare ? 'edit' : 'plus'} size={22} /></span>
              <div>
                <h3>{customerCare ? 'Edit customer care details' : 'Add customer care details'}</h3>
                <p>Configure support channels and availability</p>
              </div>
            </div>
          </div>

          <div className="prm-form-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            {error && (
              <div className="cr-error" style={{ marginBottom: 12 }}>
                <Icon name="info" size={16} /> {error}
              </div>
            )}

            <div className="prm-section-title">Phone numbers <em>*</em></div>
            {formData.phoneNumbers.map((phone, index) => (
              <div key={index} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                <input
                  type="tel"
                  className="prm-input"
                  value={phone}
                  onChange={(e) => handleArrayChange('phoneNumbers', index, e.target.value)}
                  placeholder="e.g., +91 9876543210"
                />
                <button type="button" className="prm-btn ghost sm" onClick={() => removeArrayItem('phoneNumbers', index)} title="Remove">
                  <Icon name="trash" size={14} />
                </button>
              </div>
            ))}
            <button type="button" className="prm-btn ghost sm" onClick={() => addArrayItem('phoneNumbers')}>
              <Icon name="plus" size={14} /> Add phone number
            </button>

            <div className="prm-section-title">Email addresses</div>
            {formData.emailAddresses.map((email, index) => (
              <div key={index} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                <input
                  type="email"
                  className="prm-input"
                  value={email}
                  onChange={(e) => handleArrayChange('emailAddresses', index, e.target.value)}
                  placeholder="Enter email address"
                />
                <button type="button" className="prm-btn ghost sm" onClick={() => removeArrayItem('emailAddresses', index)} title="Remove">
                  <Icon name="trash" size={14} />
                </button>
              </div>
            ))}
            <button type="button" className="prm-btn ghost sm" onClick={() => addArrayItem('emailAddresses')}>
              <Icon name="plus" size={14} /> Add email
            </button>

            <div className="prm-section-title">WhatsApp numbers</div>
            {formData.whatsappNumbers.map((wa, index) => (
              <div key={index} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                <input
                  type="tel"
                  className="prm-input"
                  value={wa}
                  onChange={(e) => handleArrayChange('whatsappNumbers', index, e.target.value)}
                  placeholder="Enter WhatsApp number"
                />
                <button type="button" className="prm-btn ghost sm" onClick={() => removeArrayItem('whatsappNumbers', index)} title="Remove">
                  <Icon name="trash" size={14} />
                </button>
              </div>
            ))}
            <button type="button" className="prm-btn ghost sm" onClick={() => addArrayItem('whatsappNumbers')}>
              <Icon name="plus" size={14} /> Add WhatsApp
            </button>

            <div className="prm-section-title">Support details</div>
            <div className="prm-fgrid">
              <Field label="Support Email">
                <input
                  type="email"
                  className="prm-input"
                  value={formData.supportEmail}
                  onChange={(e) => setFormData({ ...formData, supportEmail: e.target.value })}
                  placeholder="Enter support email"
                />
              </Field>
              <Field label="Response Time">
                <input
                  type="text"
                  className="prm-input"
                  value={formData.responseTime}
                  onChange={(e) => setFormData({ ...formData, responseTime: e.target.value })}
                  placeholder="e.g., Within 24 hours"
                />
              </Field>
              <Field label="Working Hours Start">
                <input
                  type="time"
                  className="prm-input"
                  value={formData.workingHours.start}
                  onChange={(e) => handleWorkingHoursChange('start', e.target.value)}
                />
              </Field>
              <Field label="Working Hours End">
                <input
                  type="time"
                  className="prm-input"
                  value={formData.workingHours.end}
                  onChange={(e) => handleWorkingHoursChange('end', e.target.value)}
                />
              </Field>
            </div>

            <div className="prm-section-title">Working days</div>
            <div className="prm-chips" style={{ flexWrap: 'wrap' }}>
              {DAYS.map(day => {
                const on = formData.workingDays?.includes(day);
                return (
                  <button
                    type="button"
                    key={day}
                    className={`prm-chip ${on ? 'active' : ''}`}
                    onClick={() => toggleWorkingDay(day)}
                  >
                    {on && <Icon name="check" size={12} />} {day}
                  </button>
                );
              })}
            </div>

            <div className="prm-section-title">Status</div>
            <label className="prm-check" style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              <input
                type="checkbox"
                checked={formData.isActive}
                onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
              />
              <span className="txt">{formData.isActive ? 'Active' : 'Inactive'}</span>
            </label>
          </div>

          <div className="prm-form-foot">
            <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
            <div className="prm-form-foot-actions">
              <button className="prm-btn ghost" onClick={handleCancel} disabled={loading}>
                Cancel
              </button>
              <button className="prm-btn primary" onClick={handleSubmit} disabled={loading}>
                <Icon name="check" size={15} /> {loading ? 'Saving…' : 'Save changes'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerCareManagement;